export const isMobile = (headers) => {
  const userAgent = headers ? headers['user-agent'] : navigator?.userAgent;

  return Boolean(
    userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i)
  );
};
